<template>
  <div></div>
</template>

<script>
export default {
  async created () {
    let newQuery = { ...this.$route.query }
    let sid = newQuery.sid
    if (sid) {
      this.$store.dispatch('set', {
        path: 'sid',
        value: sid
      })
      delete newQuery.sid
    }
    this.$router.push({
      path: '/',
      query: newQuery
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/page/WriteAndRedirectToHomePage.vue